import 'semantic-ui-css/semantic.min.css';
import wrapWithProvider from "./wrap-with-provider";
import {completeLoginBoot} from "./src/controllers/utilities/login-boot-shell";

export const wrapRootElement = wrapWithProvider;
export const onInitialClientRender = completeLoginBoot;
